package ai.jessie.web.profile

// Step 5: every label names its scope, so a change is never mistaken for the other one.
internal val profileLabels =
    linkedMapOf(
        FIRST_NAME to "Vorname (global)",
        LAST_NAME to "Nachname (global)",
        DISPLAY_NAME to "Anzeigename (global)",
        LOCALE to "Sprache (global)",
        MEMBER_DISPLAY_NAME to "Anzeigename in dieser Organisation",
        COMMENT_EMAIL to "E-Mail bei Kommentarzuweisung in dieser Organisation",
    )

internal fun fieldLabel(field: String) = profileLabels[field] ?: "Profil"

// The review names scope and field separately: GLOBAL or MEMBERSHIP plus the bare field name.
internal fun changeLabel(scope: String, field: String) = fieldLabel("${scope.lowercase()}.$field")

// A1, BR-185 and BR-186: the required correction, stated per field.
internal fun correction(field: String) =
    when (field) {
        FIRST_NAME,
        LAST_NAME -> "Bitte 1–250 Zeichen eingeben."
        DISPLAY_NAME -> "Bitte 1–501 Zeichen eingeben."
        LOCALE -> "Zurzeit wird nur Deutsch unterstützt."
        MEMBER_DISPLAY_NAME -> "Höchstens 100 Zeichen, oder leer lassen."
        else -> "Bitte prüfe diese Angabe."
    }

// Names are free text: only the locale and the preference are translated for display.
internal fun shown(field: String, value: String?) =
    when {
        value.isNullOrEmpty() -> "–"
        field == LOCALE && value == "de" -> "Deutsch"
        field == COMMENT_EMAIL -> if (value == "true") "ja" else "nein"
        else -> value
    }
